import React, { useState, useEffect } from "react";
import { useField } from "formik";
import { getAreaCdList } from "../../../http/api/MasterAPI";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";

const AreaCdSelect = ({ name, ...props }) => {
  const [areaCdList, setAreaCdList] = useState([]);
  const [field, meta, helpers] = useField(name);

  useEffect(() => {
    fetchAreaCdList();
  }, []);

  async function fetchAreaCdList() {
    try {
      const response = await getAreaCdList();
      const varList = response.masterVarInfo; 
      setAreaCdList(varList.map((areaVar) => ({
        areaCd: areaVar.varCd,
        areaName: areaVar.varValue1,
      })));

    } catch (error) {
      console.error("Failed to fetch sales record types:", error);
    }
  }

  const handleChange = (event) => {
    helpers.setValue(event.target.value);
    if (props.onChange) {
      props.onChange(event);
    }
  };

  return (
    <FormControl {...props} error={meta.touched && Boolean(meta.error)}>
      <InputLabel id={`${name}-label`} shrink>
        {props.label}
      </InputLabel>
      <Select
        labelId={`${name}-label`}
        id={name}
        {...field}
        onChange={handleChange}
        label={props.label}
        value={field.value === null ? -1 : field.value}
        inputRef={props.inputRef}
      >
        <MenuItem value={-1}>未選択</MenuItem>
        {areaCdList.map((area) => (
          <MenuItem
            key={area.areaCd}
            value={area.areaCd}
          >
            {area.areaName}
          </MenuItem>
        ))}
      </Select>
      {meta.touched && meta.error && (
        <FormHelperText>{meta.error}</FormHelperText>
      )}
    </FormControl>
  );
};

export default AreaCdSelect;
